import Api from "./Api";

class Project extends Api {
  constructor(version = "v1") {
    super(version);
    this.path = "projects";
  }

  getAll() {
    return new Promise((resolve, reject) => {
      this.http
        .get("/projects")
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  // Calls simplified and optimized endpoint for listing projects.
  // The response is much shorter comparing to a regular list endpoint.
  // Essentially the response contains id and name of the project and few more fields like tags.
  async getShortList (queryParams) {
    let defaultQueryParams = {
      sort_by:              'name',
      disable_pagination:   true,
      enforce_all_statuses: false,
      enforce_archived:     false
    }

    const query = Object.assign(defaultQueryParams, queryParams)
    let  queryString = Object.entries(query).map(param => param.join('=') ).join('&')

    let response = await this.http.get(`projects/short_list?${queryString}`);
    return response.data.resources;
  }

  get_project(project_id) {
    return new Promise((resolve, reject) => {
      this.http.get(`/projects/${project_id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          this.handleError(e)
          reject(e)
        })
    });
  }

  assign_user(user_id, project_id) {
    return this.assign_users([user_id], project_id);
  }

  assign_users(user_ids, project_id) {
    return new Promise((resolve, reject) => {
      this.http
        .put(this.path + "/" + project_id + "/assign_users", {
          user_ids,
          overwrite: true
        })
        .then(response => {
          resolve(response.data.resource);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  statistics_leads_count(id, params = {}) {
    let id_name = this.model_name() + "_id";
    return new Promise((resolve, reject) => {
      this.http
        .get("/statistics/projects/" + id + "/leads_count", { params })
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  unassign_user(user_id, project_id) {
    return this.unassign_users([user_id], project_id);
  }

  unassign_users(users_ids, project_id) {
    return new Promise((resolve, reject) => {
      this.http
        .put(this.path + "/" + project_id + "/unassign_users", {
          user_ids: users_ids
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  assign_businesskit(businesskit_id, project_id) {
    return new Promise((resolve, reject) => {
      this.http
        .put(this.path + "/" + project_id + "/assign_businesskit", {
          businesskit_id: businesskit_id
        })
        .then(response => {
          resolve(response.data.resource);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  assign_businesskits(businesskit_ids, project_id) {
    return new Promise((resolve, reject) => {
      this.http
        .put(this.path + "/" + project_id + "/assign_businesskits", {
          businesskit_ids,
          overwrite: true
        })
        .then(response => {
          resolve(response.data.resource);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  unassign_businesskit(businesskit_id, project_id) {
    return new Promise((resolve, reject) => {
      this.http
        .put(this.path + "/" + project_id + "/unassign_businesskit", {
          businesskit_id: businesskit_id
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  send_xls(project_id, email, locale) {
    return new Promise((resolve, reject) => {
      this.http
        .put("/projects/" + project_id + "/send_lead_export_via_email", {
          params: { email: email, locale: locale }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  lead_mask(id) {
    let id_name = this.model_name() + "_id";
    return new Promise((resolve, reject) => {
      this.http
        .get(this.path + "/" + id + "/lead_mask")
        .then(response => {
          resolve(response.data.resource);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }
  duplicate(project_id) {
    return new Promise((resolve, reject) => {
      this.http
        .post(this.path + "/" + project_id + "/clone")
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  // retrieve all the elements formatted for easy-vue-form-field collections
  // @params name : the field that will be displayed in the select (default: 'name')
  all_for_association(name = "name", params = {}) {
    if (!params.per_page) {
      params.per_page = 1000;
    }
    if (!params.sort_by) {
      params.sort_by = name;
      params.sort_order = "ASC";
    }
    return new Promise((resolve, reject) => {
      this.http
        .get(this.path + "/short_list", { params })
        .then(response => {
          let finalArray = [];
          response.data.resources.forEach(function(item) {
            finalArray.push({ value: item.id, name: eval("item." + name) });
          });
          resolve(finalArray);
        })
        .catch(e => {
          console.log(e);
          // this.handleError(e)
          reject(e);
        });
    });
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/api/Project.js